import { first, map, Observable, of } from 'rxjs';
import { InitializationService } from '../../initialization/initialization.service';
import { inject } from '@angular/core';
import { AppInitializationStatus } from '../../initialization/initialization.types';

export function consoleStatusInitializer(): Observable<boolean> {
  const initializationService = inject(InitializationService);
  return initializationService.appInitializationStatus.pipe(
    first(status => status !== AppInitializationStatus.initializing),
    map(status => status === AppInitializationStatus.consoleUp),
  );
}
